export default __webpack_public_path__ + "static/media/hero-image.8492113a.jpg";